var exports = {
  "k": "x14bf3cd8--e2e0eb--container",
};

module.exports = exports;
